// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateMachineStatusHistoryToDisplay = historyToDisplay => ({
    historyToDisplay,
    type: actions.UPDATE_MACHINE_STATUS_HISTORY_TO_DISPLAY
});

export const resetMachineStatusHistoryToDisplay = () => ({

    type: actions.RESET_MACHINE_STATUS_HISTORY_TO_DISPLAY

});



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/action-creators/criteria.js